const ROOT = 'proof-system' as const;

export interface ProofPageKeyInput {
  page: number;
  query?: string;
  stage?: string;
  eligibleUse?: string;
  sort?: string;
  locationId?: string;
  valueArea?: string;
  sourceType?: string;
  publicState?: string;
  channel?: string;
  expiration?: string;
}

function pageSignature(input: ProofPageKeyInput): string {
  return JSON.stringify([
    input.page,
    input.query ?? '',
    input.stage ?? '',
    input.eligibleUse ?? '',
    input.sort ?? '',
    input.locationId ?? '',
    input.valueArea ?? '',
    input.sourceType ?? '',
    input.publicState ?? '',
    input.channel ?? '',
    input.expiration ?? '',
  ]);
}

export const proofQueryKeys = {
  root: [ROOT] as const,
  operatorAccess: [ROOT, 'operator-access'] as const,
  raw: {
    root: [ROOT, 'raw'] as const,
    featured: () => [ROOT, 'raw', 'featured'] as const,
    page: (input: ProofPageKeyInput) => [ROOT, 'raw', 'page', pageSignature(input)] as const,
    detail: (rowId: string) => [ROOT, 'raw', 'detail', rowId] as const,
    family: (proofMetricId: string, version?: number) => [
      ROOT,
      'raw',
      'family',
      proofMetricId,
      version ?? 'latest',
    ] as const,
  },
  approved: {
    root: [ROOT, 'approved'] as const,
    picker: (contextKey: string) => [ROOT, 'approved', 'picker', contextKey] as const,
    hydration: (consumerType: string, consumerId: string, proofMetricIds: readonly string[]) => [
      ROOT,
      'approved',
      'hydration',
      consumerType,
      consumerId,
      [...proofMetricIds].sort(),
    ] as const,
  },
  aggregates: (scope: string) => [ROOT, 'aggregates', scope] as const,
  runs: (scope: 'active' | 'history' | 'all' = 'all') => [ROOT, 'runs', scope] as const,
  runsHistoryPage: (offset: number) => [ROOT, 'runs', 'history', offset] as const,
};
